import p5 from 'p5';
import { waterMarkForBg } from './template-helper';

/*
 * The Simple Border Sketch
 *
 * A simple design with a border around the edges (like a frame)
 */

// Square version
const squareSketch = function (p) {
  let watermarkDark;
  let watermarkLight;
  let interBlack;
  let interMedium;
  p.preload = function () {
    watermarkDark = p.loadImage('https://mktg-cdn.wrestlingiq.com/promos/powered_by_wiq_medium.png');
    watermarkLight = p.loadImage('https://mktg-cdn.wrestlingiq.com/promos/powered_by_wiq_medium_light.png');
    interBlack = p.loadFont('https://mktg-cdn.wrestlingiq.com/promos/fonts/Inter-Black.otf');
    interMedium = p.loadFont('https://mktg-cdn.wrestlingiq.com/promos/fonts/Inter-Medium.otf');
  }

  // These are the user editable areas of this template
  p.logo = null
  p.header = ""
  p.title = ""
  p.description = ""
  p.cta = ""
  // $n9
  p.frameColor = "#FFFFFF"
  p.bgColor = "#48647F"
  p.textColor = "#FFFFFF"
  // We expose this configuration array so the promo-generator component can show them to the user
  p.userEditableFields = function() {
    return [
      {
        id: 1,
        prompt: "Logo",
        placeholder: "",
        type: "photo",
        property: "logo",
        pinturaOpts: {
          imageCropAspectRatio: 1 / 1,
        }
      },
      {
        id: 2,
        prompt: "Header",
        placeholder: "e.g. PRESENTED BY [CLUB NAME]",
        type: "text",
        property: "header",
      },
      {
        id: 3,
        prompt: "Title",
        placeholder: "e.g. 2nd Annual Fundraiser",
        type: "text",
        property: "title",
      },
      {
        id: 4,
        prompt: "Description",
        placeholder: "e.g. when and where the event is taking place",
        type: "multiLineText",
        property: "description",
      },
      {
        id: 5,
        prompt: "Call to action",
        placeholder: "e.g. sign up at [url]",
        type: "text",
        property: "cta",
      },
      {
        id: 6,
        prompt: "Background color",
        placeholder: "",
        type: "color",
        property: "bgColor",
      },
      {
        id: 7,
        prompt: "Text color",
        placeholder: "",
        type: "color",
        property: "textColor",
      },
      {
        id: 8,
        prompt: "Frame color",
        placeholder: "",
        type: "color",
        property: "frameColor",
      }
    ]
  }
  // This is the off screen graphics buffer that contains the true dimensions
  // It is used when we need to save/download the image
  let pg;
  // p5 setup hook
  p.setup = function () {
    // TODO something about density and exports? Or just leave as is
    //  let density = p.pixelDensity()
    p.createCanvas(500, 500);
    pg = p.createGraphics(1080, 1080);
    p.noLoop();
  };
  // p5 draw loop
  p.draw = function () {
    // Draw into the offscreen graphics buffer
    pg.clear()
    pg.fill(p.bgColor)
    pg.noStroke()
    pg.rect(0, 0, 1080, 1080);
    p.describe(
      'full bleed background'
    );

    // Add the rectangular border
    pg.noFill();
    pg.strokeWeight(5);
    pg.stroke(p.frameColor);
    pg.rect(40, 40, 1000, 1000);
    p.describe(
      'Rectangular frame/border'
    );
    // Logo up top
    if (p.logo) {
      // Based on https://github.com/processing/p5.js/issues/5641
      const pImg = new p5.Image(1, 1);

      pImg.width = pImg.canvas.width = p.logo.width;
      pImg.height = pImg.canvas.height = p.logo.height;

      // Draw the image into the backing canvas of the p5.Image
      pImg.drawingContext.drawImage(p.logo, 0, 0);
      pImg.modified = true;
      // Draw it into the graphics buffer into the vertical rectangle slot
      pg.image(pImg, 465, 80, 125, 125)
    }


    // Draw the text
    pg.fill(p.textColor);
    pg.strokeWeight(0);
    pg.textSize(32);
    pg.textFont(interMedium);
    pg.textAlign(p.CENTER);
    pg.text(p.header, 540, 300);
    p.describe('Text for header')
    let titleSize = 64
    pg.textSize(titleSize);
    pg.textFont(interBlack);
    pg.textWrap(p.WORD)
    pg.textLeading(58)
    pg.text(p.title, 80, 375, 920);
    p.describe('Text for the title')
    // get title box
    let titleBounds = interBlack.textBounds(p.title, 80, 375, titleSize);
    // This is INCREDIBLY CRUDE because p5/canvas does not give us good handles
    // on actually calculating the bounds for a multi-line text box.
    // This magic number is calculated by using the preview editor, with the below log statement,
    // to see where it, roughly breaks, and then basing our layout on that
    let descriptionY = 475
    if (titleBounds.w > 900) {
      descriptionY = 605
    }
    // console.log(titleBounds);
    pg.textFont(interMedium);
    pg.textLeading(36)
    pg.textSize(32)
    pg.textWrap(p.WORD)

    pg.text(p.description, 100, descriptionY, 880);
    p.describe('Text for description')
    pg.textFont(interBlack);
    pg.textSize(32)
    pg.text(p.cta, 80, 900, 920);
    p.describe('Text for cta')

    // WrestlingIQ watermark
    let watermark = waterMarkForBg(p.bgColor, watermarkLight, watermarkDark);
    pg.image(watermark, 470, 980, 140, 42);
    // Now output the graphics buffer into the canvas element for the 'preview'
    p.image(pg, 0, 0, 500, 500)
  };

  // Exporting to the users disk
  p.exportGraphicBuffer = function() {
    pg.save('simple_border_square.png')
  }

  p.canvasWillBeRemoved = function() {
    // Remove the elements
    pg.remove();
    // Explicitly set it to null so it gets garbage collected
    pg = null;
  }
};

export const simpleBorderSquare = (node) => {
  return new p5(squareSketch, node);
};

export const simpleBorderDimensions = () => {
  return [
    {
      title: "Square",
      dimensions: "1080x1080",
      selected: false,
      initializer: simpleBorderSquare,
    }
  ]
};

export const simpleBorderPreviewImg = () => {
  return "https://mktg-cdn.wrestlingiq.com/promos/simple-border/simple_border_orange_example.png"
}
